<template>
    <v-col class="py-0">
        <v-carousel
            v-model="slide"
            class="mt-3"
            :show-arrows="false"
            hide-delimiters
            height="400"
        >
            <!-- Select the country where you will send from -->
            <v-carousel-item>
                <div>
                    <div class="text-center">
                        <v-img
                            :height="302"
                            src="/images/instructions/remitly-signup-1.png"
                            contain
                            class="mb-3 mx-auto"
                        />
                    </div>

                    <div class="mt-4 mb-4">
                        <p class="subtitle-2 mb-0">
                            Select the country where you will send from
                        </p>
                    </div>
                </div>
            </v-carousel-item>

            <v-carousel-item>
                <div>
                    <div class="text-center">
                        <v-img
                            :height="302"
                            src="/images/instructions/remitly-signup-2.png"
                            contain
                            class="mb-3 mx-auto"
                        />
                    </div>

                    <div class="mt-4 mb-4">
                        <p class="subtitle-2 mb-0">
                            1. Select the country where you will send to
                        </p>
                        <p class="subtitle-2 mb-0">
                            2. Enter your preferred email address and password
                        </p>
                        <p class="subtitle-2 mb-0">
                            3. Click Join Now
                        </p>
                    </div>
                </div>
            </v-carousel-item>
        </v-carousel>

        <v-row>
            <v-col class="col-lg-6">
                <v-btn
                    class="text-capitalize px-5 rounded-lg mr-3"
                    color="amber"
                    text
                    large
                    v-if="slide > 0"
                    @click="slide -- "
                >
                    Prev
                </v-btn>
            </v-col>

            <v-col class="d-flex justify-md-end col-lg-6">
                <v-btn
                    class="text-capitalize px-5 rounded-lg"
                    color="primary"
                    dark
                    depressed
                    large
                    @click.prevent="slide++"
                    v-if="slide < 2 - 1"
                >
                    Next
                </v-btn>
                <v-btn
                    v-else
                    class="text-capitalize px-5 rounded-lg"
                    color="primary"
                    dark
                    depressed
                    large
                    @click="$emit('proceed')"
                >
                    Proceed
                </v-btn>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
export default {
    data: () => ({
        slide: 0,
    }),
};
</script>
